module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
 if (options.showOnSaleTag && !options.showOnClearanceTag) { 
__p+='\n<div class="fmcy-sale-tag fmcy-product-tag">\n    sale\n</div>\n';
 } 
__p+='\n';
 if (options.showOnSaleTag && options.showOnClearanceTag) { 
__p+='\n<div class="fmcy-sale-tag fmcy-clearance-tag fmcy-product-tag">\n    clearance\n</div>\n';
 } 
__p+='\n';
 if (options.showCBDTag) { 
__p+='\n<div class="fmcy-cbd-tag fmcy-product-tag">\n    cbd\n</div>\n';
 } 
__p+='\n';
 if (options.showCBNCBGTag) { 
__p+='\n<div class="fmcy-cbn-cbg-tag fmcy-product-tag">\n    cbn\n</div>\n';
 } 
__p+='\n';
 if (options.showOrganicTag) { 
__p+='\n<div class="fmcy-organic-tag fmcy-product-tag">\n    organic\n</div>\n';
 } 
__p+='\n';
 if (options.showBcGrownTag) { 
__p+='\n<div class="fmcy-bc-grown-tag fmcy-product-tag">\n    bc grown\n</div>\n';
 } 
__p+='\n';
 if (options.showFarmExclusiveTag) { 
__p+='\n<div class="fmcy-is-farm-exclusive fmcy-product-tag">\n    farm exclusive\n</div>\n';
 } 
__p+='\n';
 if (options.showVeganTag) { 
__p+='\n<div class="fmcy-vegan-tag fmcy-product-tag">\n    vegan\n</div>\n';
 } 
__p+='\n';
 if (options.productTagText) { 
__p+='\n<div class="fmcy-inner-tag fmcy-product-tag">\n    <span class="fmcy-inner-tag-text">'+
((__t=( options.productTagText ))==null?'':__t)+
'</span>\n</div>\n';
 } 
__p+='\n<div class="fmcy-pointy"></div>\n';
}
return __p;
};



/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/common/product-tile/tag-bar/tag-bar.html
 ** module id = 100
 ** module chunks = 1 2 3 4 5 6 7 10 11 13 14 16 17 22 25 26 29 31 37 49 164
 **/